export class PaypalAccount {
  objectType;
  clientId;
  description;
  id;
  name;
  paypalClientSecret;
  paypalClientId;
  constructor(obj?: PaypalAccount) {
    for (const prop in obj) {
      if (obj.hasOwnProperty(prop)) {
        this[prop] = obj[prop];
      }
    }
  }
}



// WEBPACK FOOTER //
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/app/components/organization/accounts/paypal-accounts/paypal-account.model.ts